import { IClaimCalculationType } from "../interfaces/claim-calculation.interface";

export const CLAIM_CALCULATION_TYPES: Array<IClaimCalculationType> = [
  { id: 1, code: 'MANUAL', label: 'Manual' },
  { id: 2, code: 'SYNDICATED', label: 'Syndicated' },
  { id: 3, code: 'CONSULTING', label: 'Consulting' },
];
